import React from "react";
import "./Icons.scss";

const Icon = () => {
  return (
    <svg
      className="menu-icon-one-dot"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.25 23.32"
    >
      <g>
        <circle className="cls-1" cx="12.21" cy="11.25" r="0.9" />
        <circle className="cls-2" cx="12.12" cy="11.61" r="8.98" />
      </g>
    </svg>
  );
};

export default Icon;
